var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.93677C3.375 3.93677 1.125 8.99982 1.125 8.99982C1.125 8.99982 3.375 14.0618 9 14.0618C14.625 14.0618 16.875 8.99982 16.875 8.99982C16.875 8.99982 14.625 3.93677 9 3.93677Z",
    stroke: "#541FF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.8124C10.5533 11.8124 11.8125 10.5532 11.8125 8.99986C11.8125 7.44656 10.5533 6.18736 9 6.18736C7.4467 6.18736 6.1875 7.44656 6.1875 8.99986C6.1875 10.5532 7.4467 11.8124 9 11.8124Z",
    stroke: "#541FF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.598248757a9ba22bc270dfa1b12ec20c.svg";
export { ForwardRef as ReactComponent };